import { render, staticRenderFns } from "./MainCategories.vue?vue&type=template&id=0045ba43&scoped=true"
import script from "./MainCategories.vue?vue&type=script&lang=js"
export * from "./MainCategories.vue?vue&type=script&lang=js"
import style0 from "./MainCategories.vue?vue&type=style&index=0&id=0045ba43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045ba43",
  null
  
)

export default component.exports